// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { CustomAppState } from "@synd/App/Store/Reducers";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import React from "react";
import { connect, useDispatch } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => ({
    modalIsOpen: state.xCommon.isPreBookModalOpen,
});

type Props = ReturnType<typeof mapStateToProps>;

export interface PreBookModalStyles {
    modal?: ModalPresentationProps;
    messageText?: TypographyPresentationProps;
    submitButton?: ButtonPresentationProps;
}

export const preBookModalStyles: PreBookModalStyles = {
    modal: {
        sizeVariant: "small",
    },
    submitButton: {
        variant: "primary",
        css: css`
            margin-left: auto;
            margin-top: 16px;
        `,
    },
    messageText: {
        variant: "p",
        ...fontConfig.smallSingleLine,
        css: css`
            margin-bottom: 0;
        `,
    },
};

const styles = preBookModalStyles;

const PreBookModal = ({ modalIsOpen }: Props) => {
    const dispatch = useDispatch();

    const modalCloseHandler = () => {
        dispatch({
            type: "xCommon/update",
            data: {
                key: "isPreBookModalOpen",
                value: false,
            },
        } as any);
    };

    return (
        <Modal
            {...styles.modal}
            handleClose={modalCloseHandler}
            isOpen={modalIsOpen}
            headline={siteMessage("Custom_Mixed_Prebook_Cart_Heading")}
        >
            <Typography {...styles.messageText}>{siteMessage("Custom_Mixed_Prebook_Cart_Message")}</Typography>
            <Button onClick={modalCloseHandler} {...styles.submitButton}>
                {translate("Okay")}
            </Button>
        </Modal>
    );
};

export default connect(mapStateToProps)(PreBookModal);
